module.exports = __webpack_public_path__ + "static/camera-category-d10734275da5ef94d6ccaa2ffbc0776c.png";